import React from 'react'
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs'
import WrapperSection from '../../components/global/WrapperSection'
import FormAddEditUsers from '../../components/Users/FormAddEditUsers'
import { useParams } from 'react-router-dom'
import { useGetUser } from '../../hooks/Users/useGetUser'
import LoadingPage from '../../components/global/LoadingPage'

const EditUsers = () => {
    const { id } = useParams();
    const { User, isLoading } = useGetUser(id);
    if (isLoading) return <LoadingPage />;
    return (
        <>
            <WrapperSection>
                <GlobalBreadcrumbs />
                {/* Edit Users content */}
                <FormAddEditUsers isEdit={true} currentData={User?.data} />
            </WrapperSection>
        </>
    )
}

export default EditUsers